import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReferenceItem from './ReferenceItem'
import ReferenceSearch from './ReferenceSearch'
import ConnectorInfo from './ConnectorInfo'
import { ConnectorViewMappingContext } from './context/context'

const ReferenceSelector = (props) => {
  const { connector, onClick, unmappedReferences, sid, connectorViewId } = props

  const [connVwMpConxt, connVwMpConxtDispatch] = useContext(
    ConnectorViewMappingContext
  )

  const [state, setState] = useState({
    selectedReference: '',
    includeSearch: '',
    excludeSearch: '',
  })

  const includeHandler = (e) => {
    setState({
      ...state,
      includeSearch: e.target.value.toUpperCase(),
    })
  }

  const excludeHandler = (e) => {
    setState({
      ...state,
      excludeSearch: e.target.value.toUpperCase(),
    })
  }

  const pasteToIncludeSearch = (arg) => {
    setState({
      ...state,
      includeSearch: arg,
    })
  }

  useEffect(() => {
    if (connVwMpConxt?.selected_reference) {
      executeScroll(connVwMpConxt?.selected_reference)
    }
  }, [connVwMpConxt?.selected_reference])

  useEffect(() => {
    if (connector.auto_mapped) {
      executeScroll(connector.auto_mapped)
    }
  }, [])

  const { includeSearch, excludeSearch } = state

  let references = unmappedReferences
  if (connector.auto_mapped !== null && connector.reference) {
    references = [connector.reference, ...unmappedReferences]
  } else {
    references = [...unmappedReferences]
  }
  if (includeSearch && includeSearch.trim()) {
    references = references.filter((ref) => ref.includes(includeSearch))
  }
  if (excludeSearch && excludeSearch.trim()) {
    references = references.filter((ref) => !ref.includes(excludeSearch))
  }

  const executeScroll = (id) => {
    const divElement = document.getElementById(`ref-${id}`)
    if (divElement) {
      divElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="flex flex-col flex-grow items-stretch">
      <div className="flex">
        <div className="text-white p-2 w-4/5">
          <div className="font-bold">{connector.name}</div>
          <div className="text-sm">
            <div>{connector.description}</div>
            <div>Pins: {connector.cavities}</div>
            <div>
              FPN:
              <ConnectorInfo
                field={connector.fpn}
                onClick={() => pasteToIncludeSearch(connector.fpn)}
              />
            </div>
            <div>
              3D Reference:
              <ConnectorInfo
                field={connector.svg_group_reference}
                onClick={() =>
                  pasteToIncludeSearch(connector.svg_group_reference)
                }
              />
            </div>
            {connector.auto_mapped && (
              <div>
                SVG Object:
                <ConnectorInfo
                  field={connector.auto_mapped}
                  onClick={() => pasteToIncludeSearch(connector.auto_mapped)}
                />
              </div>
            )}

            <div className="text-black">
              <span className="text-white">Include Search:</span>
              <ReferenceSearch
                placeholder="Enter include value"
                value={includeSearch}
                onChange={(e) => includeHandler(e)}
              />
            </div>
            <div className="text-black">
              <span className="text-white">Exclude Search:</span>
              <ReferenceSearch
                placeholder="Enter exclude value"
                value={excludeSearch}
                onChange={(e) => excludeHandler(e)}
              />
            </div>
          </div>
        </div>
        <span
          className="cursor-pointer my-4 underline text-white text-center w-1/5"
          onClick={() => onClick(connector, null, false)}
        >
          Clear
        </span>
      </div>

      <div className="mt-6 px-1 flex-auto overflow-auto h-0">
        <div className="w-full bg-tracer-lt-blue text-white font-normal rounded-t pl-1">
          Select 3D Reference
        </div>
        {references.length > 0 ? (
          references
            .sort()
            .map((ref, idx) => (
              <ReferenceItem
                reference={ref}
                key={idx}
                selected={connVwMpConxt?.selected_reference === ref}
                sid={sid}
                connectorViewId={connectorViewId}
              />
            ))
        ) : (
          <div className="bg-white w-full px-2 py-3">No entries found</div>
        )}
      </div>
      <div
        className="btn my-4 w-full"
        onClick={() =>
          onClick(connector, connVwMpConxt?.selected_reference, true)
        }
      >
        Apply
      </div>
    </div>
  )
}

ReferenceSelector.propTypes = {
  connector: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  unmappedReferences: PropTypes.array.isRequired,
}

export default ReferenceSelector
